module.exports = "https://trybtryb-legacy.web.app/img/message_gray.af54f8f3.svg";